import { gql } from '@apollo/client';

export default gql`
  mutation completeVonagePayment(
    $bookingReference: String!
    $isDepositPayment: Boolean
    $amount: Float!
    $currency: Currency!
    $isSplitPayment: Boolean
    $isMissedDeparture: Boolean
    $isFlowForwardCapped: Boolean
    $paymentData: JSON!
  ) {
    completeVonagePayment(
      bookingReference: $bookingReference
      isDepositPayment: $isDepositPayment
      amount: $amount
      currency: $currency
      isSplitPayment: $isSplitPayment
      isMissedDeparture: $isMissedDeparture
      isFlowForwardCapped: $isFlowForwardCapped
      paymentData: $paymentData
    ) {
      reference
    }
  }
`;
